<template>
    <ModalComponent
        name='crear-codigos'
        title='Generar códigos QR para la sesión'
        @close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit" v-if="!confirmarcion && !finalizado">
            <b-row>
                <b-col cols="12">
                    <FormInput label="Cantidad de códigos QR a generar" type="number" name="cantidad_codigos" id="cantidad_codigos" rules="required" v-model="cantidad_codigos" />
                </b-col>
                <b-col cols="12" class="text-right">
                    <button type="submit" id="generar_codigos" class="btn btn-primary mb-3" :disabled="loading">Guardar</button>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div v-if="confirmarcion">
            <p>¿Estás seguro de que deseas generar {{ cantidad_codigos }} códigos QR para esta sesión?</p>
            <b-row>
                <b-col cols="12" class="text-right">
                    <button class="btn btn-secondary mr-2" @click="confirmarcion = false" :disabled="loading">Cancelar</button>
                    <button class="btn btn-primary" @click="generarCodigos" :disabled="loading">Confirmar</button>
                </b-col>
            </b-row>
        </div>
        <div v-if="finalizado">
            <p>Recibirás una notificación cuando se termine de generar los códigos QR.</p>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        data() {
            return {
                loading: false,
                cantidad_codigos: null,
                confirmarcion: false,
                finalizado: false,
            }
        },
        methods: {
            generarCodigos() {
                this.loading = true;

                var params = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    cantidad: parseInt(this.cantidad_codigos),
                    filters : {}
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.codigos-qr.generar'), params).then(res => {
                    this.confirmarcion = false;
                    this.finalizado = true;
                }).catch(e => {
                    this.close(true);
                    console.error(e);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid) {
                    this.confirmarcion = true;
                }
            },
            close(creado) {
                this.confirmarcion = false;
                this.finalizado = false;
                this.cantidad_codigos = null;
                this.$emit('close', 'crear-codigos', creado);
            }
        },
        computed: {
            evento_id() {
                return parseInt(this.$route.params.evento_id);
            },
            sesion_id() {
                return parseInt(this.$route.params.sesion_id);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
